import { createApi } from '@reduxjs/toolkit/query/react';

import baseApiQuery from '@store/baseApiQuery';

const mainApi = createApi({
  baseQuery: baseApiQuery,
  endpoints: (build) => ({
    sendContactMail: build.mutation<void, ContactFormData>({
      query: (body) => ({
        url: '/public/send-contact-mail',
        method: 'POST',
        body,
      }),
    }),
    searchCity: build.query<CityApiResult, string>({
      query: (q) => ({
        url: `https://api-adresse.data.gouv.fr/search/`,
        params: { q },
        method: 'GET',
      }),
    }),
  }),
  reducerPath: 'mainApi',
  tagTypes: [
    'UserList',
    'User',
    'CallList',
    'CallItem',
    'ProductsList',
    'SSDefaultValuesList',
    'ProspectsList',
    'ProspectsItem',
    'ContractList',
    'ContractItem',
    'Recommendations',
    'CallConfigList',
    'ProductItem',
    'NovaEventList',
    'NovaEventItem',
  ],
});

export const { useSendContactMailMutation, useLazySearchCityQuery } = mainApi;

export default mainApi;

export type ContactFormData = {
  firstName: string;
  lastName: string;
  email: string;
  subject: 'Données personnelles' | 'Réclamation légale' | 'Autres' | 'Rappelez-moi';
  message: string;
};

export type CityApiFeature = {
  properties: {
    label: string;
    city: string;
    postcode: string;
    citycode: string;
    name?: string;
    street?: string;
    housenumber?: string;
    type: 'housenumber' | 'street' | 'locality' | 'municipality';
  };
};

export type CityApiResult = {
  features: CityApiFeature[];
};

export type CityOption = {
  label: string;
  value: string;
  city: string;
  zipcode: string;
  insee: string;
};
